import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

const SITE_URL = "https://www.bosc.com.tw";
const OG_IMAGE = `${SITE_URL}/logo512.png`;

interface SeoProps {
  title: string;
  description: string;
  path: string;
}

function Seo({ title, description, path }: SeoProps) {
  const { i18n } = useTranslation();
  const lang = i18n.language === "tw" ? "zh-Hant" : "en";
  const url = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <html lang={lang} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="藍洋衝浪 Blue Ocean Surf" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:locale" content={lang === "zh-Hant" ? "zh_TW" : "en_US"} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={OG_IMAGE} />
      <link rel="alternate" hrefLang="zh-Hant" href={`${SITE_URL}${path}`} />
      <link rel="alternate" hrefLang="en" href={`${SITE_URL}${path}`} />
      <link rel="alternate" hrefLang="x-default" href={`${SITE_URL}${path}`} />
    </Helmet>
  );
}

export default Seo;
